/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type LogIn_viewer = {
    readonly id: string;
    readonly username: string | null;
    readonly isAnonymous: boolean | null;
    readonly " $refType": "LogIn_viewer";
};
export type LogIn_viewer$data = LogIn_viewer;
export type LogIn_viewer$key = {
    readonly " $data"?: LogIn_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"LogIn_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "LogIn_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "username",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isAnonymous",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'b3d61907214d82e9ca03ca74ac531344';
export default node;
